export type EnumValueType = string | number | symbol;
export type EnumType = { [key in EnumValueType]: EnumValueType };
export type ValueOf<T> = T[keyof T];
/**
 * For numerical enums TS creates an inverse map so the length of values/keys will be double
 */

export const isStringEnum = <T> (definedEnum: EnumType & T): boolean => {
  const keys = Object.keys(definedEnum);

  return keys.length === keys.filter((key) => isNaN(Number(key))).length;
};

export const isNumericEnum = <T> (definedEnum: EnumType & T): boolean => !isStringEnum(definedEnum);

export const getEnumKey = <T> (value: ValueOf<T>, definedEnum: EnumType & T): keyof T => {
  const keys = Object.keys(definedEnum);
  const values = Object.values(definedEnum);

  return keys[ values.indexOf(value as keyof T) ] as keyof T;
};

export const getEnumKeys = <T> (definedEnum: EnumType & T): (keyof T)[] => {
  if (isStringEnum(definedEnum)) {
    return Object.keys(definedEnum) as (keyof T)[];
  }

  const keys = Object.keys(definedEnum);

  return keys.filter((key) => isNaN(Number(key))) as (keyof T)[];
};

export const getEnumValues = <T> (definedEnum: EnumType & T): ValueOf<T>[] => {
  if (isStringEnum(definedEnum)) {
    return Object.values(definedEnum) as ValueOf<T>[];
  }

  return Object.values(definedEnum).filter((key) => !isNaN(Number(key))) as ValueOf<T>[];
};

export const getEnumValue = <T> (value: EnumValueType, definedEnum: EnumType & T): ValueOf<T> | undefined =>
  getEnumValues(definedEnum).find((enumValue) => enumValue === value);

export const enumIncludes = <T> (value: EnumValueType, definedEnum: EnumType & T): boolean =>
  getEnumValues(definedEnum).includes(value as ValueOf<T>);
